import React from "react";

export const EmptyState = ({ icon: Icon, title, text, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center py-14 px-4 text-center">
    {Icon && (
      <div className="mb-3 rounded-full bg-secondary p-3">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
    )}
    <p className="font-medium">{title}</p>
    {text && <p className="mt-1 text-sm text-muted-foreground max-w-sm">{text}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
